
import Showtimes1 from './Showtimes1';




const Showtimes = () => {
    // Inline styles for the container
    const appContainerStyle = {
      textAlign: 'center',
      backgroundColor: '#001f3f', // Dark Navy Blue
      color: 'white',
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
    };
  
    // Inline styles for the main content
  
    return (
      <div style={appContainerStyle}>
       <Showtimes1/>
      </div>
    );
  }
  
  export default Showtimes;
  